import { _ as __decorate, a as __metadata } from '../tslib.es6-Cv888lzs.js';
import { LitElement } from 'lit';
import { property, customElement } from 'lit/decorators.js';

/**
 * A single transferable item. Place as a direct child of `<it-transfer>`.
 * The element's text content is used as the item label.
 *
 * @slot - The label text for this item.
 */
let ItTransferItem = class ItTransferItem extends LitElement {
    constructor() {
        super(...arguments);
        /** The value submitted as part of the transfer's form value when in the target list. */
        this.value = '';
        /** If set, the item cannot be transferred. */
        this.disabled = false;
        /** If set, the item starts in the target (right) list on initialisation. */
        this.target = false;
    }
};
__decorate([
    property({ type: String, reflect: true }),
    __metadata("design:type", Object)
], ItTransferItem.prototype, "value", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItTransferItem.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, reflect: true }),
    __metadata("design:type", Object)
], ItTransferItem.prototype, "target", void 0);
ItTransferItem = __decorate([
    customElement('it-transfer-item')
], ItTransferItem);

export { ItTransferItem };
//# sourceMappingURL=it-transfer-item.js.map
